import firebase from 'firebase/app';
import 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyD6rq4eC6XTz_y8u_KHo0BYdNcA2sfEQEE",
  authDomain: "iotech-274214.firebaseapp.com",
  databaseURL: "https://iotech-274214.firebaseio.com",
  projectId: "iotech-274214",
  storageBucket: "iotech-274214.firebasestorage.app",
  messagingSenderId: "541188124489",
  appId: "1:541188124489:web:c7d7748f6db4bd2b44b498",
  measurementId: "G-J3H2SEDH8H"
};

// Inicializar Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const messaging = firebase.messaging();